module.exports = __webpack_public_path__ + "./images/p1.JPG?3293513e34a4737d758f40c5d948fa98";


//////////////////
// WEBPACK FOOTER
// ./src/products/p1.JPG
// module id = 44
// module chunks = 0